import { render, staticRenderFns } from "./c-dropzone.vue?vue&type=template&id=cd79be9c&"
import script from "./c-dropzone.vue?vue&type=script&lang=js&"
export * from "./c-dropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports